module.exports = __webpack_public_path__ + "static/icons/icon_2_signup.c6d3397.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cvc/icon_2_signup.svg
// module id = yHZE
// module chunks = 1